import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { combineLatest } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AccountRouteParams } from '../core/routeparams';
import { AccountService } from '../core/account';
import { WpCloudHostedService } from '../core/wp-cloud-hosted.service';
import { BusinessCenterRedirectService } from '../core/business-center-redirect.service';

export const wpCloudRedirectGuard: CanActivateFn = (route) => {
  const hosted = inject(WpCloudHostedService);
  const redirect = inject(BusinessCenterRedirectService);
  const accountService = inject(AccountService);
  const agid = (route.params as AccountRouteParams).accountGroupId;
  if (!agid) return true;

  return combineLatest([hosted.isHostedOnWpCloud$(agid), accountService.result()]).pipe(
    first(),
    map(([isWpCloud, account]) => {
      if (!isWpCloud) return true;
      const partnerId = account?.partnerId;
      if (!partnerId) return true;
      redirect.redirectToWpHosting(agid, partnerId);
      return false;
    }),
  );
};
